import React, { useEffect, useState } from 'react'

import { textTranslation, shouldTranslateTo } from '../utils/utils'

import styled from 'styled-components'

import {
  ContainerFlexRow,
  Input,
  Subtitle,
  LinkText,
  ActionButtons,
  CustomSubtitle,
} from './Utils/CustomClasses'
import { CustomAccordion } from './Utils/CustomComponents'
import axios from 'axios'

const Container = styled.div`
  background-color: #fff;
  /* margin-top: 40px;

    @media screen and (max-width: 820px) {
        margin-top: 65px;
    }

    @media screen and (max-width: 768px) {
        margin-top: 25px;
    } */
`

const Header = styled.div`
  padding: 20px 5vw 70px 5vw;
  background-color: #f2e8d8;

  & > div {
    margin: 0 auto;
  }

  @media screen and (max-width: 820px) {
    padding: 20px 7vw 70px 7vw;
  }
`

const HeaderText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 40px;
  align-items: center;
  text-align: center;

  max-width: 730px;

  @media screen and (max-width: 767px) {
    gap: 20px;
  }
`

const SearchDiv = styled.div`
  padding-top: 60px;
  max-width: 780px;

  @media screen and (max-width: 767px) {
    padding-top: 40px;
  }
`

const Body = styled.div`
  padding: 70px 14vw;

  @media screen and (max-width: 820px) {
    padding: 35px 7vw;
  }
`

const Category = styled.div`
  &:not(:last-child) {
    margin-bottom: 55px;
  }
`

const CategoryTitleDiv = styled.div`
  width: 100%;
  padding: 20px 10px;
  background-color: ${(props) => (props.color ? props.color : '#fff')};
  text-align: center;
  margin-bottom: 20px;
`

const CustomContainerFlexRow = styled(ContainerFlexRow)`
  @media screen and (max-width: 1025px) {
    flex-direction: row;
  }

  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`

const InputContainer = styled.div`
  display: flex;
  width: 100%;
  position: relative;

  img {
    /* button position */
    position: absolute;
    right: 16px;
    top: 8px;
    bottom: 0;
    /* button appearane */
    justify-content: center;
    align-items: center;
    width: 25px;
    height: 25px;
    appearance: none;
    border: none;
    margin: 10px;
    padding: 2px;
    font-size: 25px;
    cursor: pointer;

    @media screen and (max-width: 768px) {
      top: 3px;
    }
  }
`

const FAQ = () => {
  const [pageText, setPageText] = useState([])

  const [becomeMember, setBecomeMember] = useState(null)
  const [homestaysHost, setHomestaysHost] = useState(null)
  const [homestaysGuest, setHomestaysGuest] = useState(null)

  const [inputText, setInputText] = useState(null)
  const [keySearch, setKeySearch] = React.useState('')

  useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/pages/faqs/${languageValue}`)
        .then((response) => {
          const { content, content1 } = response.data
          setBecomeMember(content[0])
          setHomestaysHost(content[1])
          setHomestaysGuest(content[2])
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })

      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
          // this.setState({
          //   footerData: pageText
          // });
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('faqs', language)
  }, [])

  const SearchBox = () => {
    const handleSearch = (props) => {
      if (inputText === null) return

      setKeySearch(inputText)
    }

    return (
      <CustomContainerFlexRow gap="0px" gapMd="0" gapSm="0">
        <InputContainer>
          <Input
            id="search-key"
            type="text"
            name="search"
            margin="0"
            marginsm="0"
            // className={stateError && "red-border"}
            placeholder={pageText[3]}
            required
            autoFocus
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
          />
          {inputText !== null && (
            <img
              src="/images/icons/close.svg"
              alt="clear-search"
              onClick={() => {
                setInputText(null)
                setKeySearch('')
              }}
            />
          )}
        </InputContainer>
        <ActionButtons
          background="#154549"
          isDisabled={inputText === null}
          onClick={handleSearch}
        >
          {pageText[4]}
        </ActionButtons>
      </CustomContainerFlexRow>
    )
  }

  const CategoryTitle = ({ title, color }) => {
    return (
      <CategoryTitleDiv color={color}>
        <CustomSubtitle size="27px" sizemd="22px">
          {title}
        </CustomSubtitle>
      </CategoryTitleDiv>
    )
  }

  if (
    pageText == undefined ||
    becomeMember == undefined ||
    homestaysHost == undefined ||
    homestaysGuest == undefined ||
    pageText.length === 0 ||
    becomeMember.length === 0 ||
    homestaysHost.length === 0 ||
    homestaysGuest.length === 0
  ) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      <Header>
        <HeaderText>
          <Subtitle bold size="50px" sizemd="40px" sizesm="30px">
            {pageText[0]}
          </Subtitle>
          <Subtitle bold size="22px" sizemd="22px">
            {pageText[1]}
          </Subtitle>
          <CustomSubtitle
            weight="400"
            size="18px"
            sizemd="18px"
            dangerouslySetInnerHTML={{ __html: `${pageText[2]}` }}
          />
        </HeaderText>
        <SearchDiv>
          <SearchBox />
        </SearchDiv>
      </Header>
      <Body>
        <Category>
          {becomeMember &&
            becomeMember.items.filter(
              (item) =>
                item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
                item.a.toLowerCase().includes(keySearch.toLowerCase())
            ).length > 0 && (
              <CategoryTitle title={becomeMember.title} color="#E1F5F7" />
            )}
          {becomeMember &&
            becomeMember.items.map((item, index) => {
              return (
                <>
                  {keySearch !== '' ? (
                    keySearch &&
                    (item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
                      item.a
                        .toLowerCase()
                        .includes(keySearch.toLowerCase())) && (
                      <CustomAccordion
                        title={item.q}
                        children={item.a}
                        key={index}
                      />
                    )
                  ) : (
                    <CustomAccordion
                      title={item.q}
                      children={item.a}
                      key={index}
                    />
                  )}
                </>
              )
            })}
        </Category>

        <Category>
          {console.log('homestaysHost: ' + JSON.stringify(homestaysHost))}
          {homestaysHost &&
            homestaysHost.items.filter(
              (item) =>
                item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
                item.a.toLowerCase().includes(keySearch.toLowerCase())
            ).length > 0 && (
              <CategoryTitle title={homestaysHost.title} color="#E2F4E6" />
            )}
          {homestaysHost &&
            homestaysHost.items.map((item, index) => {
              return (
                <>
                  {keySearch !== '' ? (
                    keySearch &&
                    (item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
                      item.a
                        .toLowerCase()
                        .includes(keySearch.toLowerCase())) && (
                      <CustomAccordion
                        title={item.q}
                        children={item.a}
                        key={index}
                      />
                    )
                  ) : (
                    <CustomAccordion
                      title={item.q}
                      children={item.a}
                      key={index}
                    />
                  )}
                </>
              )
            })}
        </Category>

        <Category>
          {homestaysGuest &&
            homestaysGuest.items.filter(
              (item) =>
                item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
                item.a.toLowerCase().includes(keySearch.toLowerCase())
            ).length > 0 && (
              <CategoryTitle title={homestaysGuest.title} color="#F2E8D8" />
            )}
          {homestaysGuest &&
            homestaysGuest.items.map((item, index) => {
              return (
                <>
                  {keySearch !== '' ? (
                    keySearch &&
                    (item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
                      item.a
                        .toLowerCase()
                        .includes(keySearch.toLowerCase())) && (
                      <CustomAccordion
                        title={item.q}
                        children={item.a}
                        key={index}
                      />
                    )
                  ) : (
                    <CustomAccordion
                      title={item.q}
                      children={item.a}
                      key={index}
                    />
                  )}
                </>
              )
            })}
        </Category>
        {becomeMember &&
          becomeMember.items.filter(
            (item) =>
              item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
              item.a.toLowerCase().includes(keySearch.toLowerCase())
          ).length === 0 &&
          homestaysHost &&
          homestaysHost.items.filter(
            (item) =>
              item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
              item.a.toLowerCase().includes(keySearch.toLowerCase())
          ).length === 0 &&
          homestaysGuest &&
          homestaysGuest.items.filter(
            (item) =>
              item.q.toLowerCase().includes(keySearch.toLowerCase()) ||
              item.a.toLowerCase().includes(keySearch.toLowerCase())
          ).length === 0 && <Subtitle>{pageText[5]}</Subtitle>}
      </Body>
    </Container>
  )
}

export default FAQ
